export default {
    props: {
        audioFile: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            currentlyPlaying: false,
            currentlyStopped: false,
            currentTime: 0,
            trackDuration: 0,
            currentProgressBar: 0,
            checkingCurrentPositionInTrack: '',
            audio: '',
            options: {},
        }
    },
    filters: {
        timeFormat(s) {
            let min = (s - (s %= 60)) / 60
            return (9 < min ? '' : '0') + min + (9 < s ? ':' : ':0') + s
        }
    },
    created() {
        this.changeSong()
    },
    mounted() {
        this.changeSong()
        this.audio.loop = false
    },
    methods: {
        changeSong() {
            const wasPlaying = this.currentlyPlaying
            this.audio = new Audio(this.audioFile)
            const contx = this
            this.audio.addEventListener('loadedmetadata', function () {
                if (this.duration !== Infinity) {
                    contx.trackDuration = Math.round(this.duration)
                }
            })
            this.audio.addEventListener('ended', this.handleEnded)
            if (wasPlaying) {
                this.playAudio()
            }
        },
        playAudio() {
            if (!this.currentlyPlaying) {
                this.getCurrentTimeEverySecond(true)
                this.currentlyPlaying = true
                this.audio.play()
            } else {
                this.stopAudio()
            }
            this.currentlyStopped = false
        },
        stopAudio() {
            this.audio.pause()
            this.currentlyPlaying = false
            this.pausedMusic()
        },
        handleEnded() {
            this.stopAudio()
        },
        getCurrentTimeEverySecond(startStop) {
            const cotx = this
            this.checkingCurrentPositionInTrack = setTimeout(
                function () {
                    cotx.currentTime = cotx.audio.currentTime
                    cotx.trackDuration = cotx.audio.duration - cotx.currentTime

                    cotx.currentProgressBar = Math.round(
                        (cotx.currentTime / cotx.audio.duration) * 100
                    )
                    cotx.getCurrentTimeEverySecond(true)
                }.bind(this),
                10
            )
        },
        pausedMusic() {
            clearTimeout(this.checkingCurrentPositionInTrack)
        }
    },
    watch: {
        currentTime() {
            this.currentTime = Math.round(this.currentTime)
        },
        trackDuration() {
            this.trackDuration = Math.round(this.trackDuration)
        },
        audioFile() {
            this.$nextTick((vm) => {
                this.changeSong()
            })
        }
    },
    beforeDestroy() {
        this.audio.removeEventListener('ended', this.handleEnded)
        this.audio.removeEventListener('loadedmetadata', this.handleEnded)
        clearTimeout(this.checkingCurrentPositionInTrack)
    }
}